import React from 'react'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import RemoteAutocompleteWithSearch from '@components/form/RemoteAutocompleteWithSearch';
import {Input} from '@components/form/Input'
import {Select} from '@components/form/Select'
import RemoteAutocompleteSelect from "@components/form/RemoteAutocompleteSelect";
import {SimpleDialog} from "@components/form/SimpleDialog";
import {LabelButton} from "@components/common/buttons/LabelButton";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import clsx from "clsx";
import 'dayjs/locale/ru'
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@components/form/Checkbox";
var dayjs = require('dayjs')
var LocalizedFormat = require('dayjs/plugin/localizedFormat')
dayjs.extend(LocalizedFormat)
const merge = require('deepmerge');

export class NewTaskComponent extends React.Component {
    initState = {
        form : {
            user_id: null,
            title: null,
            comment: null,
            entity_type: '',
            entity_id: 0,
            reminder_type: '',
            reminder_start: null,
            reminder_end: null,
            is_report_required: false
        },
        taskDuration: 15,
        errors: {}
    }
    state = {
        open: false,
        addAnotherTask: false,
        ...this.initState
    }

    async componentDidUpdate(prevState, prevProps) {
        if (this.state.open && this.state.open != prevProps.open) {
            if (this.props.task) {
                let {task} = this.props;
                task.reminder_start = dayjs(task.reminder_start).format('YYYY-MM-DDTHH:mm');
                task.reminder_end = dayjs(task.reminder_end).format('YYYY-MM-DDTHH:mm');
                this.setState({
                    form: merge(this.state.form, {...task}),
                });
            } else if (this.state.open != prevProps.open) {
                this.setState({
                    ...this.initState,
                    form: merge(this.initState.form, {entity_type: this.props.orderId ? 'order' : '', entity_id: this.props.orderId || 0}),
                });
            }
        }
    }

    changeTasks = async() => {
        let {form} = this.state;
        let request = {
            ...form,
            reminder_start: dayjs(form.reminder_start).format('YYYY-MM-DD HH:mm:ss'),
            reminder_end: dayjs(form.reminder_end).format('YYYY-MM-DD HH:mm:ss'),
        }
        let response;
        if (this.props.task) {
            response = await this.props.updateUserTask(this.props.task.id, request);
        } else {
            response = await this.props.addUserTask(request);
        }
        if (response.errors && Object.keys(response.errors).length) {
            this.setState({errors: response.errors});
        } else {
            if (response.data) {
                if (this.state.addAnotherTask) {
                    if (this.props.onSubmitRedirect) {
                        this.props.onSubmitRedirect(response.data[0]);
                    }
                    this.setState({...this.state, form: {
                        ...this.state.form,
                        title: '',
                        comment: '',
                        entity_type: '',
                        entity_id: 0
                    }})
                } else {
                    this.setState({open: false});
                    if (this.props.onSubmitRedirect) {
                        this.props.onSubmitRedirect(response.data[0]);
                    } else {
                        history.go();
                    }
                }
            }
        }
    }

    input = ({name, label, type, className}) => (
        <Input
            name={name}
            label={label}
            type={type}
            value={this.state.form[name]}
            className={className || this.props.classes.input}
            onChange={({target: {value}}) => {
                this.setState({form: {...this.state.form, [name]: value}}, () => {
                    if (name === 'reminder_start') {
                        this.setTaskDuration(this.state.taskDuration);
                    }
                });
            }}
            InputLabelProps={{
              shrink: true,
            }}
            errors={this.state.errors}
            fullWidth
            variant={'outlined'}
            margin={'normal'}
            size={'small'}
        />
    )

    setTaskDuration = (value) => {
        let {reminder_start} = this.state.form;
        this.setState({
            form: {...this.state.form, reminder_end: dayjs(reminder_start).add(value, 'minute').format('YYYY-MM-DDTHH:mm')},
            taskDuration: value
        });
    }

    render() {
        const {classes, context: {user}} = this.props;
        return(<SimpleDialog
            fullWidth={true}
            maxWidth={'lg'}
            open={this.state.open}
            onClose={(e) => this.setState({open: false})}
            title={ this.props.task
                ? 'Редактирование задачи'
                : 'Создание задачи' }
            icon={this.props.customOpenButton
                ? <div onClick={e => this.setState({open : true})}>{this.props.customOpenButton}</div>
                : this.props.task
                    ? <EditOutlinedIcon
                        onClick={(e) => this.setState({open: true})}
                        color={'primary'}
                    />
                    : <LabelButton
                        onClick={e => this.setState({open: true})}
                        title={'Добавить задачу'}
                        icon={<AddCircleRoundedIcon color={'primary'} />}
                        disableMarginTop
                    />}
            actions={[
                (<Button
                    onClick={(e) => this.changeTasks()}
                    color="primary" variant="contained"
                >
                    Сохранить
                </Button>),
            ]}
        >
            <Grid container spacing={3} className={classes.gridContainer}>
                <Grid item xs={12} md={6}>
                    {this.input({label: 'Заголовок', name:'title', type:'text', className: clsx([classes.input, classes.resetInputMarginTop])})}

                    <RemoteAutocompleteSelect
                        url={'/api/v1/autocomplete/users'}
                        name={'user_id'}
                        value={this.state.form.user_id}
                        errors={this.state.errors}
                        label="Исполнитель"
                        onChange={(e, {value}) => this.setState({form: {...this.state.form, user_id: value}})}
                        fullWidth
                        variant={'outlined'}
                        margin={'normal'}
                        className={classes.input}
                        size={'small'}
                    />
                    <div
                        style={{
                            color: '#3f51b5',
                            cursor: 'pointer',
                            marginBottom: '8px',
                            fontSize: '14px'
                        }}
                        onClick={e => this.setState({form: {...this.state.form, user_id: user.id}})}
                    >
                        Назначить меня
                    </div>

                    <Grid container spacing={3} className={classes.periods_container} alignItems={'center'}>
                        <Grid item xs={12} sm={6}>
                            {this.input({label: 'Начало', name:"reminder_start", type: 'datetime-local'})}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {this.input({label: 'Окончание', name:"reminder_end", type: 'datetime-local'})}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Select
                                disabled={!this.state.form.reminder_start}
                                label={'Длительность'}
                                options={[10, 15, 20, 30, 45, 60, 90, 120].map(item => {return {value: item, label: `${item} мин.`}})}
                                displayEmpty={false}
                                value={this.state.taskDuration}
                                onChange={({target: {value}}) => this.setTaskDuration(value)}
                                fullWidth
                                variant={'outlined'}
                                margin={'normal'}
                                className={clsx([classes.input, classes.resetMarginBottom__desktop])}
                                size={'small'}
                            />
                        </Grid>
                        {!this.props.task ? <Grid item xs={12} sm={6}>
                            <FormControlLabel
                                control={<Checkbox
                                    checked={this.state.addAnotherTask}
                                    onChange={() => this.setState({...this.state, addAnotherTask: !this.state.addAnotherTask})}
                                />}
                                className={clsx([classes.inputMarginTop, classes.inputMarginBottom])}
                                label="Создать ещё одну задачу"
                            />
                        </Grid> : null}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Checkbox
                                    checked={!!this.state.form.is_report_required}
                                    onChange={() => {
                                        this.setState({form: {
                                                ...this.state.form,
                                                is_report_required: !!!this.state.form.is_report_required
                                            }});
                                    }}
                                />}
                                className={clsx([classes.inputMarginTop, classes.inputMarginBottom, classes.resetMarginBottom__desktop])}
                                label="Необходим отчет по завершению задачи"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Input
                        name={'comment'}
                        multiline={true}
                        rows={3}
                        placeholder="Описание"
                        errors={this.state.errors}
                        value={this.state.form.comment}
                        onChange={({target: {value}}) => this.setState({form: {...this.state.form, comment: value}})}
                        fullWidth
                        variant={'outlined'}
                        margin={'normal'}
                        className={clsx([classes.input, classes.resetInputMarginTop__desktop])}
                        size={'small'}
                    />
                    <Select
                        label={'Тип задачи'}
                        name={'reminder_type'}
                        options={[{label: 'Задача', value: 'task'}, {label: 'Другое', value: 'other'}]}
                        value={this.state.form.reminder_type}
                        displayEmpty
                        errors={this.state.errors}
                        onChange={({target: {value}}) => this.setState({form: {...this.state.form, reminder_type: value}})}
                        fullWidth
                        variant={'outlined'}
                        margin={'normal'}
                        className={classes.input}
                        size={'small'}
                    />
                    <Select
                        label={'Связь задачи'}
                        name={'entity_type'}
                        options={[{label: 'Заказ', value: 'order'}, {label: 'Другое', value: 'other'}]}
                        value={this.state.form.entity_type}
                        displayEmpty
                        errors={this.state.errors}
                        onChange={({target: {value}}) => this.setState({form: {...this.state.form, entity_type: value}})}
                        fullWidth
                        variant={'outlined'}
                        margin={'normal'}
                        className={classes.input}
                        size={'small'}
                    />
                    {this.state.form.entity_type === 'order' && <RemoteAutocompleteWithSearch
                        name={'entity_id'}
                        url={'/api/v1/autocomplete/orders'}
                        SearchString={this.state.searchString}
                        value={this.state.form.entity_id}
                        label="Заказ"
                        errors={this.state.errors}
                        onChange={(e, target) => this.setState({form: {...this.state.form, entity_id: target?.value}})}
                        fullWidth
                        variant={'outlined'}
                        margin={'normal'}
                        className={classes.input}
                        size={'small'}
                    />}
                </Grid>
            </Grid>
        </SimpleDialog>)
    }
}
